import angular from "angular";

import { moduleName as recordsModuleName } from "../../../records";
import { vsModuleName as shareMachineModuleName } from "../../shared";
import { machineConfigurationConfig } from "./machineConfiguration";
import { machineDetailTabComponentConfigure } from "./configureMachineDetailTabs";
import { machineConfig } from "./machine";
import { machineGameConfig } from "./machineConfigurationTypeGameConfiguration";

import { vsModuleName as lookupConfigModuleName } from "./lookup/module";
import { machineEpromConfigurationConfig } from "./machineEpromConfigurations";
import { machineConfigurationTypeConfig } from "./machineConfigurationType";
import { vsModuleName as changesConfigModule } from "./changes";

export const vsModuleName = "SlotTrak.Machines.Config";

angular
  .module(vsModuleName, [
    recordsModuleName,
    shareMachineModuleName,
    lookupConfigModuleName,
    changesConfigModule,
  ])
  .config(machineConfigurationConfig)
  .config(machineDetailTabComponentConfigure)
  .config(machineConfig)
  .config(machineGameConfig)
  .config(machineEpromConfigurationConfig)
  .config(machineConfigurationTypeConfig);
